"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-17.jpg" | "/Templates/Doccure/img/blog/blog-18.jpg" | "/Templates/Doccure/img/blog/blog-19.jpg" */
    src: string;
    /** Detected variants: "Understanding Your Fertility Health" | "The Role of Nutrition in Fertility" | "Lifestyle Habits That Boost Fertility" */
    link0Text: ReactNode;
    /** Detected variants: "Many couples don’t realize that simple lifestyle factors, and timing all play a major role in conception." | "This blog shares simple nutrition tips that support improve egg and sperm quality" | "This article covers everyday habits that support reproductive health naturally." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-4 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "blog-item-ten w-100 wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "blog-img" */
    div0ClassName2?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "blog" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href?: string;
};
export type HomeTenBlogSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection46sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Blog" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Helpful Reads for Growing Families" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    blogSection46s: BlogSection46sItem[];
    blogSection46sItemWrapper?: (item: BlogSection46sItem, content: ReactNode) => ReactNode;
    blogSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection46sLinkVisible?: boolean;
    blogSection46sLinkRenderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sImageVisible?: boolean;
    blogSection46sImageRenderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sH3Visible?: boolean;
    blogSection46sH3Renderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTenBlogSectionGenerated: FC<HomeTenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Blog",
    sectionDiv0Div0H20H2Text = "Helpful Reads for Growing Families",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogSection46s,
    blogSection46sItemWrapper,
    blogSection46sRenderer,
    blogSection46sLinkVisible,
    blogSection46sLinkRenderer,
    blogSection46sImageVisible,
    blogSection46sImageRenderer,
    blogSection46sH3Visible,
    blogSection46sH3Renderer,
    blogSection46sLinkProps,
    blogSection46sImageProps,
    blogSection46sH3Props,
}) => {
    return (
        <section className="blog-section-ten section">
            <div className="container">
                <div className="section-header section-header-ten text-center">
                    <div className="section-sub-title">
                        <span className="sec-circle" aria-hidden="true" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-4"}>
                    {renderCollectionNode(
                        blogSection46s,
                        (item: BlogSection46sItem) => (
                            <div className={item.className ?? "col-xl-4 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-ten w-100 wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "blog-img"}>
                                        {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(blogSection46sImageVisible, blogSection46sImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "blog"} {...(typeof blogSection46sImageProps === "function" ? blogSection46sImageProps(item) : (blogSection46sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        {renderItemNode(blogSection46sH3Visible, blogSection46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection46sH3Props === "function" ? blogSection46sH3Props(item) : (blogSection46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.blogDetails"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection46sItemWrapper,
                        blogSection46sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTenBlogSectionGenerated;
